import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NormalizedPlanBaseModel } from '@frontend/unhideschool/modules/membership/models/membership-normalized-plan.model';

@Component({
  selector: 'unh-price-box-simple',
  templateUrl: './price-box-simple.component.html',
  styleUrls: ['./price-box-simple.component.scss']
})
export class PriceBoxSimpleComponent {
  @Input() ispro: boolean;
  @Input() plan: any;
  @Output() actionClicked = new EventEmitter();
}
